import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { PrimaryButtonComponent } from "../../../../shared/components/primary-button/primary-button.component";

@Component({
  selector: 'app-flex-upgrade',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, PrimaryButtonComponent],
  templateUrl: './flex-upgrade.component.html',
  styleUrl: './flex-upgrade.component.css'
})
export class FlexUpgradeComponent {
  @Input() showUpgrade: boolean = false;
  @Input() label: string = 'shared.upgrade_info';
  @Input() height: string = 'h-[100%]';
  @Input() showTextUnder: boolean = false;
  @Input() textUnder: string = 'shared.forecast';

  isExpanded = false;

  constructor(private router: Router) { }

  isMobile(): boolean {
    return window.innerWidth <= 767;
  }


  openPlansPage() {
    this.router.navigate(['/settings/plans']);
  }

  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
  }

  setSidebarStatus(status: boolean) {
    if (this.isMobile()) {
      return
    }
    this.isExpanded = status;
  }
}
